import { useContext, useState, useEffect } from 'react';
import PageContext from './PageContext';
import WorkflowCommentLog from '../sub-components/WorkflowCommentLogCopy';
import { HttpContext } from '../../api-services/HttpService';
import CCOffcanvas from "./CCOffcanvas.tsx";
import ButtonComponent from "../sub-components/ButtonComponent"
import ApiRequestButton from "../sub-components/ApiRequestButton"
import  '../../css/offcanvasStyle.css'; 
import EllipsisInfoLabel from './EllipsisInfoLabel.jsx';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonthRounded';

const RebatePayoutEditModal = () => {
    // get context variables from parent
    const {
        pencilModal,
        setPencilModal,
        editRow,
        refreshSummaryData,
        snackbarAlert,
    } = useContext(PageContext);
    // initialize http context 

    const {
        POST,
    } = useContext(HttpContext);

    const formatDateToString = (date) => {
        if (!date) return null;
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    }

    const getValidDate = (dateStr) => {
        if (!dateStr || dateStr === 'null' || dateStr === 'undefined') return null;
        
        const parsedDate = new Date(dateStr);
        // Check if it's an Invalid Date
        if (isNaN(parsedDate.getTime())) {
            return null;
        }
        
        return parsedDate;
    }

    // initialize state
    const [commentText, setCommentText] = useState('');
    const [payPeriodDate, setPayPeriodDate] = useState(null);

    useEffect(() => {
        setPayPeriodDate(getValidDate(editRow.payperiod));
    }, [editRow]);

    // create function for creating a new comment
    const updatePayPeriodAndComment = (workflowid, commenttype, commenttext, paymentdate) => {
        return POST('/rebate/summary/payperiod/edit', { workflowid: workflowid, commenttype: commenttype, commenttext: commenttext, updatedpaymentdate: paymentdate })
                .then(() => {
                    //close modal
                    setPencilModal(false);
                    //reset comment text to blank incase user returns to make another comment
                    setCommentText('');
                    // success alert
                    snackbarAlert(true, 'Successfully updated data.', 'success');
                    // refresh table
                    refreshSummaryData();
                })
                .catch(err => {
                    console.log(err);
                    //show alert
                    snackbarAlert(true, 'Error updating data.', 'error');
                });
    }

    const handleChange = (newVal) => {
        setPayPeriodDate(newVal);
    }

    const onSubmitClick = () => {
        const originalDate = getValidDate(editRow.payperiod);
        
        // Validate date is selected and different from original
        if (!payPeriodDate || isNaN(payPeriodDate.getTime())) {
            snackbarAlert(true, 'Please select a valid pay period date.', 'warning');
            return Promise.reject();
        }
        
        if (payPeriodDate.toDateString() === originalDate?.toDateString()) {
            snackbarAlert(true, 'Please select a different pay period date.', 'warning');
            return Promise.reject();
        }
        
        // Validate comment text is not empty
        if (!commentText || commentText.trim() === '') {
            snackbarAlert(true, 'Please enter a comment.', 'warning');
            return Promise.reject();
        }
        
        return updatePayPeriodAndComment(editRow.workflowid, editRow.userroleid, commentText, formatDateToString(payPeriodDate));
    }
    
    return (
        <CCOffcanvas
            title={"Edit Pay Period"}
            show={pencilModal}
            onCanvasClose={() => {setCommentText(''); setPencilModal(false)}}
            bodyCssClassName="offcanvas-body"
            offCanvasClassName="offcanvas-parent-card"
        >
            {/* read only input for info on rebate workflow that is being viewed */}
            <div className="bg-white p-3" style={{fontSize: '14px'}}>
                <div className="d-flex gap-3 flex-wrap">
                    <EllipsisInfoLabel title={'Company Name:'} content={editRow.mastercompanyname} maxChar='50'/>
                    <div className="vr"></div>
                    <EllipsisInfoLabel title={'Payout Cycle:'} content={editRow.periodcyclestart + '-' + editRow.periodcycleend + ' [' + editRow.incentivefreq + ']'} maxChar='20'/>
                </div>
            </div>
            <div style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 100px)', paddingBottom: '80px' }}> 
                {/* dropdown */}
                <div className="p-3 pb-0 comment-section">
                    <div className="bg-white comment-card" >
                    <div className="offcanvas-details p-3" style={{fontSize: '12px', borderBottom: "1px solid #ECECEC"}}>Pay Period</div>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker 
                                size = 'small'
                                value={payPeriodDate}
                                format="yyyy-MM-dd"
                                onChange={handleChange}
                                emptyLabel='None' 
                                views={['year', 'month', 'day']} 
                                slotProps={{ textField: { size: 'small' } }}
                                slots={{ 
                                    openPickerIcon: () => <CalendarMonthIcon sx={{color: 'black'}}/>
                                }}
                                className='date-class'
                                sx={{padding:"0.6em 0.9em",width:"100%"}}
                            />
                        </LocalizationProvider>
                    </div>
                </div>
                {/* comment log to show all comments attached to rebate workflow */}   
                <div className="p-3 comment-section">
                    <div className="bg-white comment-card" >
                        <WorkflowCommentLog workflowid={editRow.workflowid} disableHeight/>
                        {/* textarea input for new comment */}

                        <div className="p-3" style={{borderTop: "1px solid #ECECEC"}}>
                            <input className="w-100 input-text-field" value={commentText} onChange={(e) => setCommentText(e.target.value)} placeholder='Type comments here'></input>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end p-3 w-100 position-absolute bottom-0 offcanvas-footer">
                    <ButtonComponent tag={"Cancel"} 
                        border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                        onButtonClick={() => {setCommentText(''); setPencilModal(false)}}
                    />
                    <ApiRequestButton 
                        onButtonClick={onSubmitClick}
                    />
            </div>
        </CCOffcanvas>
    );
}

export default RebatePayoutEditModal;